import script from "./VerifyOtpPage.vue?vue&type=script&setup=true&lang=js"
export * from "./VerifyOtpPage.vue?vue&type=script&setup=true&lang=js"

import "./VerifyOtpPage.vue?vue&type=style&index=0&id=38f1c2af&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38f1c2af"]])

export default __exports__